module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-Regular.396e556.woff";